import { getTokenQRString } from "helpers/configandapiurls";
import React, { useEffect } from "react";
import Barcode from "react-barcode";
import { useTranslation } from "react-i18next";
import QRCode from "react-qr-code";
import { useDispatch, useSelector } from "react-redux";
import { IKioskModel, ITemplateData } from "../../../../models/kioskModel";
import { printTokenRequest } from "store/actions";

const ThemeOneTokenGeneration: React.FC = () => {
  const { t } = useTranslation("translations");
  const dispatch = useDispatch();
  const buttonDisable = useSelector(
    (state: any) => state?.kioskReducer?.printButtondisble || false
  );
  let templateData: ITemplateData = useSelector((state: any) => {
    if (state && state.kioskReducer && state.kioskReducer.templateData)
      return state.kioskReducer.templateData;
    else return undefined;
  });
  let tokenNo = useSelector((state: any) => {
    if (state && state.kioskReducer && state.kioskReducer.tokenNo)
      return state.kioskReducer.tokenNo;
    else return undefined;
  });
  const errorMessage = useSelector(
    (state: any) => state.kioskReducer.errorMessage
  );

  const language = useSelector((state: any) => {
    if (state?.kioskReducer?.language)
      return (state.kioskReducer as IKioskModel).language;
    else return "";
  });

  console.log(
    "ThemeOneTokenGeneration =>",
    errorMessage,
    templateData,
    tokenNo
  );

  useEffect(() => {
    if (templateData && templateData.templates) {
      (document.getElementById("tokenTemplate1") as any).innerHTML =
        templateData.templates.length >= 1 ? templateData.templates[0] : "";
      (document.getElementById("tokenTemplate2") as any).innerHTML =
        templateData.templates.length >= 2 ? templateData.templates[1] : "";
    }
  }, [templateData]);

  return (
    <>
      <div className="kiosk-content">
        {!errorMessage && templateData && templateData.templates && (
          <div className="qr_mainContainer">
            <div className="qrSection">
              <div className="tableCard">
                <section id="tokenTemplate1"></section>
                {templateData.mrnNo && (
                  <section id="barcodeTemplate" className="text-center">
                    <Barcode
                      value={templateData.mrnNo}
                      textMargin={-5}
                      marginTop={0}
                      height={50}
                      displayValue={true}
                    />
                  </section>
                )}
                <section id="tokenTemplate2"></section>
              </div>
            </div>
            <div className="token_msg">{t("Kiosk.tokendown") + language}</div>
            <button
              className="print_button"
              disabled={buttonDisable}
              onClick={() =>
                dispatch(
                  printTokenRequest(
                    templateData?.templateOrg,
                    templateData.tokenNo
                  )
                )
              }
            >
              {t("Kiosk.printToken" + language)}
            </button>
            <span className="line"> </span>
            {/* <div className="qr_img"> */}
            {/* <div className="text-center"> */}
            {/* <h3>{t("Kiosk.thankYou" + language)}</h3> */}
            {/* <h1>{templateData.tokenNo}</h1> */}
            {/* <p>{t("Kiosk.tokenGeneratedSuccessfully" + language)}</p> */}
            {/* </div> */}
            {/* </div> */}
            <div className="qr_img grid_gp">
              <>
                <p>{t("Kiosk.scanTokenQr" + language)}</p>
                <QRCode value={getTokenQRString()} size={250} />
                <p className="pStyle">
                  {t("Kiosk.scanQRCodeBottom" + language)}
                </p>
              </>
            </div>
          </div>
        )}
        {errorMessage && (
          <div className="text-white">
            <h5>{errorMessage}</h5>
          </div>
        )}
      </div>
    </>
  );
};
export default React.memo(ThemeOneTokenGeneration);
